import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum EPlanningsRoute {
  plannings = 'plannings',
  summary = 'summary',
  myPlannings = 'myPlannings',
  calendars = 'calendars',
  scheduler = 'scheduler',
  timeEntries = 'timeEntries',
  timeEntryView = 'time-entry-view',
  list = 'list',
  missionView = 'missionView',
}

CamRoutes.addRoute({
  key: EPlanningsRoute.plannings,
  url: 'plannings',
  children: [
    {
      key: EPlanningsRoute.summary,
      url: 'summary',
    },
    {
      key: EPlanningsRoute.myPlannings,
      url: 'myPlannings',
    },
    {
      key: EPlanningsRoute.calendars,
      url: 'calendars',
    },
    {
      key: EPlanningsRoute.scheduler,
      url: 'scheduler',
    },
    {
      key: EPlanningsRoute.timeEntries,
      url: 'time-entries',
      children: [
        {
          key: EPlanningsRoute.list,
          url: 'list',
        },
      ],
    },
    {
      key: EPlanningsRoute.timeEntryView,
      url: 'time-entry-view/:id',
    },
    {
      key: EPlanningsRoute.missionView,
      url: 'mission-view/:id',
    },
  ],
});

export const planningsRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.summary]),
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./pages/plannings.component').then(c => c.PlanningsPage),
    children: [
      {
        path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.summary]),
        loadComponent: () =>
          import('./pages/dashboard/plannings-dashboard.component').then(c => c.PlanningsDashboardPage),
      },
      {
        path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.myPlannings]),
        loadComponent: () => import('./pages/my-planning/my-planning.component').then(c => c.MyPlanningPage),
      },
      {
        path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.calendars]),
        loadComponent: () => import('./pages/calendars/calendars.component').then(c => c.CalendarsPage),
      },
      {
        path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.scheduler]),
        loadComponent: () => import('./pages/scheduler/scheduler.component').then(c => c.SchedulerPage),
      },
      {
        path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.timeEntries]),
        children: [
          {
            path: '',
            redirectTo: CamRoutes.getAbsoluteUrl([
              EPlanningsRoute.plannings,
              EPlanningsRoute.timeEntries,
              EPlanningsRoute.list,
            ]),
            pathMatch: 'full',
          },
          {
            path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.timeEntries, EPlanningsRoute.list]),
            loadComponent: () =>
              import('./pages/time-entries/list/time-entries.component').then(c => c.TimeEntriesPage),
          },
        ],
      },
    ],
  },
  {
    path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.timeEntryView]),
    loadComponent: () => import('./pages/time-entries/view/time-entry-view.component').then(c => c.TimeEntryViewPage),
  },
  {
    path: CamRoutes.getUrl([EPlanningsRoute.plannings, EPlanningsRoute.missionView]),
    loadComponent: () => import('./pages/missions/view/mission-view.component').then(c => c.MissionViewPage),
  },
];
